<template>

<div>
    <el-container class="elcontainer" style="position:relative;overflow-x:true">
        <el-aside width="200px" style="background-color: rgb(238, 241, 246);overflow-x: hidden;">
            <div class="lefttop">
              <div class="title">智能跳绳校园版</div>
              <div class="img">
                <img src="../assets/logo.png" alt="">
              </div>
              <div class="name">{{userInfo.user_nickname}}</div>
              <div class="banji">{{default_class.class_name}}{{default_class.type_name}}</div>
              <div class="qiehuan">
                <el-link type="primary" @click="addBanji">新增班级</el-link>
                <el-link type="warning" @click="changeBanji">切换班级</el-link>
              </div>
            </div>
            <MaliangMenu :isCollapse="isCollapse" :list="menuOptions">
            </MaliangMenu>
        </el-aside>
        <el-container>
          <el-header style="min-width:800px">
            <div class="header">
              <div class="title">
                <i class="el-icon-menu"></i>
                <span>{{urltitle}}</span>
              </div>
              <div class="header-right">
                <div class="gateway">网关:<span>{{default_mac}}</span>  <el-button size="mini" type="primary" @click="showGateway">切换网关</el-button></div>
                <div class="loginout" @click="loginout">
                    <i class="el-icon-warning"></i>
                    <span>退出</span>
                </div>
              </div>
            </div>
          </el-header>
          <el-main style="min-width:800px">
            <div class="contentbox">
              <router-view></router-view>
            </div>
          </el-main>
        </el-container>
    </el-container>

    <!--新增班级弹窗-->
    <el-dialog title="新增班级" :visible.sync="showadd" width="500px">
      <el-form :model="form" style="width:100%">
        <el-form-item label="选择类别" :label-width="formLabelWidth">
          <el-select v-model="form.type1" @change="changeClassType" placeholder="请选择选择类别">
            <el-option v-for="(item,index) in school_type" :key="index" :label="item.name" :value="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择年级" :label-width="formLabelWidth">
          <el-select v-model="form.type2" placeholder="请选择年级">
            <template v-if="form.type1 !== ''">
                <el-option v-for="(item,index) in school_type[form.type1].children" :key="index" :label="item.name" :value="index"></el-option>
            </template> 
          </el-select>
        </el-form-item>
        <el-form-item label="选择班级" :label-width="formLabelWidth">
          <el-select v-model="form.type3" placeholder="请选择班级">
            <el-option v-for="(item,index) in 30" :key="index" :label="item+'班'" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="showadd = false">取 消</el-button>
        <el-button size="small" type="primary" @click="handleAddClass">确 定</el-button>
      </div>
    </el-dialog>

    <!--切换班级弹窗-->
    <el-dialog title="切换班级" :visible.sync="show">
      <el-table :data="gridData">
        <el-table-column property="class_name" label="年级" width="200"></el-table-column>
        <el-table-column property="type_name" label="班级"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
            size="mini"
            type="primary"
            :disabled="default_class.id == scope.row.id"
            plain
            @click="handleChange(scope.$index, scope.row)">切换</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!--切换网关弹窗-->
    <el-dialog title="切换网关" :visible.sync="showgate">
      <el-table :data="gatewayData">
        <el-table-column property="mac" label="网关编号" width="200"></el-table-column>
        <el-table-column property="name" label="网关名称"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
            size="mini"
            type="primary"
            :disabled="default_mac == scope.row.mac"
            plain
            @click="handleChangeGateway(scope.$index, scope.row)">切换</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

</div>
    
</template>
    
<script>
import { logout } from '@/api/user'
import { teacherClass,mySchoolType,addClass,schoolGateway } from '@/api/school'
import { removeToken } from '@/utilities/auth'
//引用菜单 后期 从 接口返回 存入 vuex
import menulist from "@/utilities/menu.js";
import MaliangMenu from "@/components/basic/MaliangElementMenu.vue";
import { mapState } from 'vuex'
export default {
    components:{
        MaliangMenu
    },
    data(){
        return{
            isCollapse: false,
            menuOptions: menulist,
            title:'控制台',
            showadd:false,//新增班级弹窗
            show:false,//选择班级弹窗
            formLabelWidth: '120px',
            form:{
              type1:'',
              type2:'',
              type3:''
            },
            gridData:[],
            school_type:'',
            showgate:false,
            gatewayData:[]
        }
    },
    computed:{
        ...mapState({
            userInfo: state => state.system.userInfo,
            default_class:state=>state.system.default_class,
            default_mac:state=>state.system.default_mac
        }),
        urltitle(){
            //console.log(this.$store.state)
            return this.$store.state.system.urltitle;
        }
    },
    methods:{
        showGateway(){
            schoolGateway(this.default_class.school_id).then(res=>{
                if(res.code == 1){
                    this.gatewayData = res.data
                    this.showgate = true
                    console.log(this.gatewayData)
                }else{
                    this.$message.error("没有网关设备")
                }
            })
        },
      // 切换网关
      handleChangeGateway(index,row){
        console.log(index,row)
        this.$store.state.system.default_mac = row.mac
        this.showgate = false
      },
      //新增班级
      addBanji(){
        this.showadd=true;
        //获取班级类型
        mySchoolType(this.default_class.school_id).then(res=>{
            console.log('班级类型')
            this.school_type = [res.data]
            this.form.type1 = 0
            console.log(this.school_type)
        })
      },
      //选择班级
      changeBanji(){
        this.show=true;
        // 获取老师班级列表
        teacherClass().then(res=>{
            console.log('班级列表信息', res)
            this.gridData = res.data
        })
      },
      //确认选择班级
      handleChange(index,row){
        console.log(index)
        console.log(row)
        console.log(this.default_class)
        this.$store.commit('setDefaultClass',row)
        this.show=false;
        window.location.reload()
      },
      //确认添加班级
      handleAddClass(){
        console.log('班级信息',this.form)
        if(this.form.type1 === '' || this.form.type2 === '' || this.form.type3 === ''){
            this.$message.error("班级信息未完善");
            return false;
        }
        let class_type = this.school_type[this.form.type1].id+'-'+this.school_type[this.form.type1].children[this.form.type2].id;
        let class_name = this.school_type[this.form.type1].children[this.form.type2].name
        let type_name = this.form.type3+'班'
        addClass({class_type,class_name,type_name}).then(res=>{
            if(res.code == 1){
                this.showadd = false
                this.form = {
                type1:'',
                type2:'',
                type3:''
                }
            }else{
                this.$message.error(res.msg);
            }
        })
      },
      changeClassType(){
        this.form.type2 = "";
        this.form.type3 = "";
      },
      //退出系统
      loginout(){
        logout().then(res=>{
                if(res.code == 1){
                    removeToken()
                    this.$router.push({ path: 'login' })
                }
            })
      }
    },
    created(){
        console.log(this.default_class)
        console.log(this.$route.path)

        let path=this.$route.path;
        
        var route;
            this.menuOptions.forEach(item=>{
                if(item.children.length>0){
                    item.children.forEach(child=>{
                        if(child.path==path){
                            route=child;
                        }
                    })
                }else{
                    if(item.path==path){
                        route=item;
                    }
                }
            })
            if(route){
              //this.urltitle=route.name;
              this.$store.commit('setUrlTitle', route.name)
            }
            
        
        console.log(route)

  },
}
</script>

<style lang="scss" scoped>
body{
  background:#f5f5f5;
}
.elcontainer{
  position:fixed;
  top:0;
  bottom:0;
  left:0;
  right:0;
}
.lefttop{
  background:url('../assets/images/topbg.png') no-repeat;
  display:flex;
  flex-direction:column;
  align-items:center;
  padding-top:5px;
  padding-bottom:25px;
  .title{
    color:#fff;
    font-size:14px;
  }
  .img{
    padding-top:5px;
    img{
      width:45px;
      height:45px;
      border-radius:50%;
      overflow:hidden;
      object-fit:cover;
    }
  }
  .name{
    color:#000;
    font-size:14px;
  }
  .banji{
    color:#000;
    font-size:12px;
    padding-top:5px;
  }
  .qiehuan{
    width:100%;
    padding-top:25px;
    display:flex;
    align-items:center;
    justify-content:space-around;
  }
}
.header {
    display: flex;
    align-items: center;
    padding: 20px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    background: #fff;
    justify-content: space-between;
    .header-right {
        display:flex;
        align-items: center;
        .gateway span {color:#409EFF;margin-right:10px;font-weight:bold;}
    }
    .loginout {
        margin-left:20px;
      cursor: pointer;
    }
    span {
      padding-left: 5px;
    }
  }
  .contentbox {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background: #fff;
    height: 100%;
    width: 100%;
    display: flex;
    overflow-y:scroll;
    padding:0 25px;
  }
</style>
